import { initialState } from "../store/ActiveConferenceSlice";

export default function formatMeetingData(data, clientUserId) {
    try {
    const localParticipant = data.conferenceParticipants.find((p) => p.user_id === clientUserId)
    if (!localParticipant) return initialState;
    return {
        uiState: {
            is_conference_active: data.is_active,
            participant: {
                is_participant: localParticipant.role === "guest"
            },
            master: {
                is_master: localParticipant.role === "master",
                is_principal_master: localParticipant.role === "principal-master"
            },
        },
        conference: {
            id: data.id,
            date: data.date,
            room_id: data.room_id,
            title: data.title,
            description: data.description,
            allow_mic: data.allow_mic,
            allow_camera: data.allow_camera,
            allow_screen_share: data.allow_screen_share,
            allow_audio: data.allow_audio,
            allow_reaction: data.allow_reaction,
            allow_messages: data.allow_messages,
            ext_inscription: data.ext_inscription,
            registration_link: data.registration_link,
            email_confirmation_enabled: data.email_confirmation_enabled,
            reminder_on_event_day: data.reminder_on_event_day,
            reminder_5_min_before: data.reminder_5_min_before,
            photo: data.photo,
            actions: data.conferenceAction,
            participants: data.conferenceParticipants,
            conversation:data.conversation,
        }
    }
    } catch (e) {
        console.error("Error parsing meeting data", data, clientUserId)
        return initialState;
    }

}